/** Keep an incomplete NPC visible without substituting another NPC's artwork. */
export function selectNpcFrame<T extends { w: number; h: number; atlasIndex: number }>(
  frames: (T | undefined)[] | undefined,
  requested: number,
): T | undefined {
  if (!frames) return undefined;
  const valid = (frame: T | undefined): frame is T =>
    !!frame && frame.atlasIndex >= 0 && frame.w > 0 && frame.h > 0;
  if (valid(frames[requested])) return frames[requested];
  const upLeft = [2, 3, 8, 9, 10, 11, 14, 15].includes(requested);
  const standing = frames[upLeft ? 2 : 0];
  if (valid(standing)) return standing;
  return [frames[0], frames[2]].find(valid);
}
